import image1 from "./Images/1754216209987.jpg"
import image2 from "./Images/1754216209999.jpg"
import image3 from "./Images/1754216210012.jpg"
import image4 from "./Images/1754216210025.jpg"
import image5 from "./Images/1754216210037.jpg"
import image6 from "./Images/1754216210048.jpg"
import image7 from "./Images/1754216210060.jpg"
import image8 from "./Images/1754216210072.jpg"
import image9 from "./Images/1754216210083.jpg"
import image10 from "./Images/1754216210095.jpg"
import image11 from "./Images/1754216210107.jpg"
import image12 from "./Images/1754216210122.jpg"
import image13 from "./Images/1754216210137.jpg"
import image14 from "./Images/1754216210159.jpg"
import image15 from "./Images/1754216210171.jpg"
import image16 from "./Images/1754216210181.jpg"
import image17 from "./Images/1754216210196.jpg"
import image18 from "./Images/1754216210207.jpg"
import image19 from "./Images/1754216210218.jpg"
import image20 from "./Images/1754216210232.jpg"
import image21 from "./Images/1754216210259.jpg"
import image22 from "./Images/1754216210281.jpg"
import image23 from "./Images/1754216210300.jpg"
import image24 from "./Images/1754216210316.jpg"
import image25 from "./Images/1754216210335.jpg"
import image26 from "./Images/1754216210349.jpg"
import image27 from "./Images/1754216210371.jpg"
import image28 from "./Images/1754216210382.jpg"
import image29 from "./Images/1754216210359.jpg"

export const SearchImages = [
    { link: image1, isDeleted: false,title:"raju159 netlify" },
    { link: image2, isDeleted: false,title:"Raju singh Computer Science Engineer" },
    { link: image3, isDeleted: false, title: "Raju singh Mobile Developer" },
    { link: image4, isDeleted: false, title: "Raju singh Master in React js" },
    { link: image5, isDeleted: false, title: "Raju singh smart worker Software Engineer" },
    { link: image6, isDeleted: false, title: "Raju singh Best Engineer" },
    { link: image7, isDeleted: false, title: "Raju Singh Top Software Engineer" },
    { link: image8, isDeleted: false, title: "Raju Singh Tandaspur Engineer" },
    { link: image9, isDeleted: false, title: "raju singh bihar netlify" },
    { link: image10, isDeleted: false, title: "raju singh IT Engineer" },
    { link: image11, isDeleted: false, title: "raju singh Full Stack Developer" },
    { link: image12, isDeleted: false, title: "raju singh performance focus web apps" },
    { link: image13, isDeleted: false, title: "raju singh Robust web apps" },
    { link: image14, isDeleted: false, title: "Raju Singh Scalable web apps" },
    { link: image15, isDeleted: false, title: "Raju Singh Express" },
    { link: image16, isDeleted: false, title: "Raju Singh Node.js" },
    { link: image17, isDeleted: false, title: "Raju Singh React" },
    { link: image18, isDeleted: false, title: "Raju Singh React" },
    { link: image19, isDeleted: false, title: "Raju Singh Javascript" },
    { link: image20, isDeleted: false, title: "Raju Singh Mern Stack" },
    { link: image21, isDeleted: false, title: "Raju Singh Mern Stack Developer" },
    { link: image22, isDeleted: false, title: "Raju Singh Full Stack Developer" },
    { link: image23, isDeleted: false, title: "Raju Singh Software Engineer" },
    { link: image24, isDeleted: false, title: "who is full stack developer raju singh" },
    { link: image25, isDeleted: false, title: "who is full stack developer raju singh" },
    { link: image26, isDeleted: false, title: "who is full stack developer raju singh" },
    { link: image27, isDeleted: false, title: "full stack developer raju singh" },
    { link: image28, isDeleted: false, title: "full stack developer raju singh" },
    { link: image29, isDeleted: false, title: "full stack developer raju singh" }

  ];
  